import { useEffect, useState } from 'react';
import { categories, merchCategories } from '../api/categories';

export const useFilterOptions = () => {
  const [categoryOptions, setCategoryOptions] = useState<{ value: string; label: string }[]>([]);
  const [merchCategoryOptions, setMerchCategoryOptions] = useState<
    { value: string; label: string }[]
  >([]);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await categories.getAll();
        setCategoryOptions(data.map((c) => ({ value: c.id.toString(), label: c.name })));
      } catch (error) {
        console.error('Failed to load categories:', error);
      }
    };
    loadCategories();
  }, []);

  useEffect(() => {
    const loadMerchCategories = async () => {
      try {
        const data = await merchCategories.getAll();
        setMerchCategoryOptions(data.map((c) => ({ value: c.id.toString(), label: c.name })));
      } catch (error) {
        console.error('Failed to load merch categories:', error);
      }
    };
    loadMerchCategories();
  }, []);

  return {
    categoryOptions,
    merchCategoryOptions,
  };
};
